/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
import { SupportedLocale } from '../model.js';
/**
 * Resolve the display locale.
 *
 * @param fallbackLocale a fallback locale (eg. fr_FR).
 * @returns a locale.
 */
export function resolveDisplayLocale(fallbackLocale) {
    // get browser locales.
    const browserLocales = navigator.languages;
    for (const browserLocale of browserLocales) {
        // iterate over browser locales.
        let supportedLocale;
        for (supportedLocale of Object.values(SupportedLocale)) {
            // locale found.
            if (browserLocale === supportedLocale.replace('_', '-')) {
                return supportedLocale;
            }
        }
    }
    // not found.
    return fallbackLocale;
}
//# sourceMappingURL=languages.js.map